import React from 'react';
import t from 'prop-types';
import './Hidden.scss';

const styles = {
    mdUp: 'mdUp',
    mdDown: 'mdDown'
};

const Hidden = ({ children, breakpoint, style }) => (
    <div className={styles[breakpoint]} style={style}>
        {children}
    </div>
);

Hidden.propTypes = {
    children: t.node.isRequired,
    breakpoint: t.oneOf(['xsUp', 'smUp', 'mdUp', 'lgUp', 'xsDown', 'smDown', 'mdDown', 'lgDown'])
        .isRequired,
    style: t.shape({})
};

Hidden.defaultProps = {
    style: {}
};

export default Hidden;



// WEBPACK FOOTER //
// ./src/components/Hidden/Hidden.js